export default {
    fillToLiveList(state,data){
         data=Object.assign({},state.data,data)
         state.data=data
//         console.log("state.data",state.data);
//         if (typeof (state.data)=="undefined"){
//             state.data={}
//         }
//         let __VALUE__ = JSON.parse(JSON.stringify(state.data))
//         console.log("__VALUE__",__VALUE__)
// // 加入部门回复详情
//         let time=Date.parse(new Date());
//         data[time]=time
//         __VALUE__ =data
// // 更新，只能这样一波骚操作才能让computed和watch监听到。具体原因我稍后学习o(╥﹏╥)o。
//         state.data = __VALUE__
        // state.data=data;
    }
}
